import React from 'react';
import './RerollButton.css'
import {WAR_COLOR} from "../../../styles/constants";
import {REGISTRY_SINGLETON} from "../../../scenes/Registry";

export const SOUND_TIMEOUT_AFTER_REROLL = 500;

const RerollButton = ({handleRerollClick, isDisabledStyle, isShooting, isShootingUnit, isUnitMeleeElf}) => {
  const onClick = () => {
    handleRerollClick((isDice1Selected, isDice2Selected, isBadLuck) => {
      const soundManager = REGISTRY_SINGLETON.getSoundManager()

      soundManager.playRerollDices(isDice1Selected, isDice2Selected)

      setTimeout(() => {
        // Переброс выстрела повторяет залп на поле (см. playShotAnimation), и
        // звучит он как выстрел при любом исходе — так же, как у наблюдателей
        // (playEffectForServerAction): при неудаче ее сигнал приходит к
        // попаданию. Без этого валун неудачного переброса летел бы в тишине
        if (isShooting) {
          soundManager.playShooting(isUnitMeleeElf, isShootingUnit, isBadLuck);
          return;
        }

        if (isBadLuck) {
          soundManager.playRerollBadLuck();
          return;
        }

        soundManager.playMeleeCombatAfterReroll();
      }, SOUND_TIMEOUT_AFTER_REROLL)
    })
  }

  return (
    <button
      className={`city-capture-modal-button reroll-button ${isDisabledStyle ? 'gui-disabled-look' : ''}`}
      style={{backgroundColor: WAR_COLOR}}
      onClick={onClick}
    >
      <h2>Перебросить</h2>
      <img
        className={'combat-controls_icon reroll-button-dice'}
        src={'/img/icons/cube supply outline.png'}
        alt={'dice'}
      />
      <h2>за</h2>
      <img
        className={'combat-controls_icon reroll-button-supply'}
        src={'/img/icons/supply outline.png'}
        alt={'supply'}
      />
    </button>
  );
};

export default RerollButton;